export const REQUEST_DEVICES = 'userDevices/REQUEST';
export const REQUEST_REMOVE_DEVICE = 'userDevices/REQUEST_REMOVE';

export const SET_DEVICES = 'userDevices/SET_DEVICES';
export const REMOVE_DEVICE_SUCCESS = 'userDevices/REMOVE_SUCCESS';
export const RESET_DEVICES = 'userDevices/RESET_DEVICES';
